<template>
  <search @search="search" v-model="searchValue">
    <div slot="content">
      <div class="navTabBar">
        <div class="nav-item" :class="{current: filterIndex === 0}" @click="tabClick(0)">全部</div>
        <div class="nav-item" :class="{current: filterIndex === 1}" @click="tabClick(1)">视频</div>
        <div class="nav-item" :class="{current: filterIndex === 2}" @click="tabClick(2)">音频</div>
        <div class="nav-item" :class="{current: filterIndex === 3}" @click="tabClick(3)">图文</div>
        <!-- <span class="cate-item yticon icon-fenlei1" @click="toggleCateMask('show')"></span> -->
      </div>
      <my-refresh-more
        ref="refresh"
        :pageSize="10"
        v-model="goodsList"
        :getList="getList"
        :getParams="getParams"
        :params="{filterIndex,priceOrder,searchValue,fid,sid,tid}"
      >
        <div slot="list" class="goods-list">
          <div
            v-for="(item, index) in goodsList"
            :key="index"
            class="goods-item"
            @click="navToDetailPage(item)"
          >
            <div class="image-wrapper">
              <van-image
                lazy-load
                class="image-wrapper-image"
                :src="item.picture"
                mode="aspectFill"
              />
            </div>
            <div class="text-wrapper">
              <span class="title clamp">{{item.name}}</span>
              <div>
                <span
                  class="price"
                >{{!!item.marketingCampaignPrice?item.marketingCampaignPrice:item.price}}</span>
                <van-tag v-if="item.marketingCampaignType==1" type="danger">团购价</van-tag>
                <van-tag v-if="item.marketingCampaignType==2" type="danger">限时折扣</van-tag>
              </div>
              <div class="price-box">
                <span class>{{item.teacherName}}</span>
                <span>浏览量 {{item.scanNum}}</span>
              </div>
            </div>
          </div>
        </div>
      </my-refresh-more>
    </div>
  </search>
</template>

<script>
import search from '../base.vue';
export default {
  components: {
    search
  },
  data () {
    return {
      searchValue: '',
      filterIndex: 0,
      priceOrder: 0, //1 价格从低到高 2价格从高到低
      cateList: [],
      goodsList: [],
      fid: 0, //一级Id
      sid: 0, //二级Id
      tid: 0 //三级Id
    };
  },

  created () {
    let query = this.$route.query
    this.fid = query.fid;
    this.sid = query.sid;
    this.tid = query.tid;
    this.title = query.title;
    this.setTitle()
  },
  methods: {
    //加载分类
    loadCateList () {
      this.$http.request(this.$http.pathMap.categoryTree, 'get').then(res => {
        let cateList = res.data;
        cateList.forEach(item => {
          if (item.id == this.fid) {
            this.cateList = item.children
          }
        })
      })
    },
    getParams () {
      let {
        filterIndex,
        priceOrder,
        searchValue,
        fid,
        sid,
        tid,
      } = this
      return {
        filterIndex,
        priceOrder,
        searchValue,
        fid,
        sid,
        tid,
      }
    },
    setTitle () {
      if (this.title) {
        document.title = this.title
      }
    },
    search (value) {
      this.searchValue = value
      this.$refs.refresh.refreshList()
    },
    getList (page, size, param) {
      console.log(param)
      let {
        fid,
        sid,
        tid,
        filterIndex,
        priceOrder,
        searchValue
      } = param
      let id = tid * 1 ? tid * 1 : sid * 1 ? sid * 1 : fid * 1
      let params = {
        page: page,
        size: size,
        name: searchValue,
        sortId: id
      }

      if (filterIndex != 0) {
        params.type = filterIndex
      }
      return new Promise((resolve, reject) => {
        this.$http.request(this.$http.pathMap.courseList, 'get', params).then(res => {
          let data = res.data
          data.list.forEach(item => {
            item.picture = item.picture.length > 0 ? item.picture[0] : ''
          })
          resolve(data)
        })
      })
    },
    //筛选点击
    tabClick (index) {
      this.filterIndex = index;
      console.log('tabClick', this.filterIndex)
      this.$refs.refresh.refreshList()
    },
    //显示分类面板
    toggleCateMask (type) {
      let timer = type === 'show' ? 10 : 300;
      let state = type === 'show' ? 1 : 0;
      this.cateMaskState = 2;
      setTimeout(() => {
        this.cateMaskState = state;
      }, timer)
    },
    //分类点击
    changeCate (sitem, titem) {
      this.sid = sitem.id;
      this.tid = titem.id;
      this.toggleCateMask();
      this.$refs.refresh.refreshList()
    },
    //详情
    navToDetailPage (item) {
      let id = item.id;
      this.$router.push({
        path: '/onlinePages/course/course',
        query: {
          id
        }
      })
    },
    stopPrevent () { }
  },
}
</script>

<style lang="scss" scoped>
.navTabBar {
  display: flex;
  width: 100%;
  height: 40px;
  background: #fff;
  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.06);
  z-index: 10;

  .nav-item {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    font-size: 15px;
    color: $font-color-dark;
    position: relative;

    &.current {
      color: $base-color;

      &:after {
        content: "";
        position: absolute;
        left: 50%;
        bottom: 0;
        transform: translateX(-50%);
        width: 60px;
        height: 0;
        border-bottom: 2px solid $base-color;
      }
    }
  }

  .p-box {
    display: flex;
    flex-direction: column;

    .yticon {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 15px;
      height: 7px;
      line-height: 1;
      margin-left: 2px;
      font-size: 13px;
      color: #888;

      &.active {
        color: $base-color;
      }
    }

    .xia {
      transform: scaleY(-1);
    }
  }

  .cate-item {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 40px;
    position: relative;
    font-size: 22px;

    &:after {
      content: "";
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      border-left: 1px solid #ddd;
      width: 0;
      height: 18px;
    }
  }
}

/* 分类 */
.cate-mask {
  position: fixed;
  left: 0;
  top: var(--window-top);
  bottom: 0;
  width: 100%;
  background: rgba(0, 0, 0, 0);
  z-index: 95;
  transition: 0.3s;

  .cate-content {
    width: 315px;
    height: 100%;
    background: #fff;
    float: right;
    transform: translateX(100%);
    transition: 0.3s;
  }

  &.none {
    display: none;
  }

  &.show {
    background: rgba(0, 0, 0, 0.4);

    .cate-content {
      transform: translateX(0);
    }
  }
}

.cate-list {
  display: flex;
  flex-direction: column;
  height: 100%;

  .cate-item {
    display: flex;
    align-items: center;
    height: 45px;
    padding-left: 15px;
    font-size: 14px;
    color: #555;
    position: relative;
  }

  .two {
    height: 32px;
    color: #303133;
    font-size: 15px;
    background: #f8f8f8;
  }

  .active {
    color: $base-color;
  }
}

/* 商品列表 */
.goods-list {
  display: flex;
  flex-wrap: wrap;
  padding: 0 15px;
  background: #fff;

  .goods-item {
    display: flex;
    flex-direction: row;
    width: 100%;
    padding-bottom: 10px;
    padding-top: 10px;
  }

  .image-wrapper {
    width: 110px;
    height: 110px;
    border-radius: 3px;
    overflow: hidden;

    .image-wrapper-image {
      width: 100%;
      height: 100%;
      opacity: 1;
    }
  }
  .text-wrapper {
    flex: 1;
    margin-left: 10px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .title {
    font-size: $uni-font-size-lg;
    color: $font-color-dark;
  }

  .price-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-right: 10px;
    font-size: 12px;
    color: $font-color-light;
  }

  .price {
    font-size: $uni-font-size-lg;
    color: var(--theme-font-color);
    line-height: 1;

    &:before {
      content: "￥";
      font-size: 13px;
    }
  }
}
.van-tag {
  transform: scale(0.7);
}
</style>
